import React from "react";

interface MagnifyIconProps {
  size?: number;
}

const MagnifyIcon: React.FC<MagnifyIconProps> = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.10539 0.900598C2.7846 0.900598 0.901199 2.7846 0.901199 5.10479C0.901199 7.42499 2.7846 9.30898 5.10539 9.30898C7.42499 9.30898 9.30958 7.42499 9.30958 5.10479C9.30958 2.7846 7.42499 0.900598 5.10539 0.900598ZM3.15899 4.65659H4.65899V3.15659C4.65899 2.9082 4.86059 2.7066 5.10899 2.7066C5.35739 2.7066 5.55899 2.9082 5.55899 3.15659V4.65659H7.05899C7.30739 4.65659 7.50899 4.85819 7.50899 5.10659C7.50899 5.35499 7.30739 5.55659 7.05899 5.55659H5.55899V7.05659C5.55899 7.30499 5.35739 7.50659 5.10899 7.50659C4.86059 7.50659 4.65899 7.30499 4.65899 7.05659V5.55659H3.15899C2.91059 5.55659 2.709 5.35499 2.709 5.10659C2.709 4.85819 2.91059 4.65659 3.15899 4.65659Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.10539 10.2096C6.35159 10.2096 7.49459 9.76138 8.38199 9.01858L11.2314 11.868C11.3196 11.9562 11.4348 12 11.55 12C11.6778 12 12 11.9022 12 11.55C12 11.4342 11.9562 11.319 11.8686 11.2314L9.01918 8.38138C9.76198 7.49519 10.2102 6.35159 10.2102 5.10479C10.2102 2.2872 7.92239 0 5.10539 0C2.2872 0 0 2.2872 0 5.10479C0 7.92239 2.2872 10.2096 5.10539 10.2096ZM0.901199 5.10479C0.901199 2.7846 2.7846 0.900598 5.10539 0.900598C7.42499 0.900598 9.30958 2.7846 9.30958 5.10479C9.30958 7.42499 7.42499 9.30898 5.10539 9.30898C2.7846 9.30898 0.901199 7.42499 0.901199 5.10479Z"
      fill="white"
    />
  </svg>
);

export default MagnifyIcon;
